import { render, staticRenderFns } from "./_base-heading-page.vue?vue&type=template&id=48fd34e3&scoped=true&lang=pug&"
import script from "./_base-heading-page.vue?vue&type=script&lang=js&"
export * from "./_base-heading-page.vue?vue&type=script&lang=js&"
import style0 from "./_base-heading-page.vue?vue&type=style&index=0&id=48fd34e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fd34e3",
  null
  
)

export default component.exports